export default __webpack_public_path__ + "static/media/API-Gateway.5c732558.svg";